export default "__VITE_ASSET__CWbp88Qr__"